import { Injectable } from '@angular/core';
import { ICmsProviderAbstract } from '../content/component/provider/icms-provider-abstract';
import { ICmsCoreIntegrationAbstractService } from './icms-core-integration-abstract.service';

@Injectable({ providedIn: 'root' })
export class ICmsCoreIntegrationProviderService extends ICmsCoreIntegrationAbstractService<ICmsProviderAbstract<any>> {}
